import request from '@/utils/request';
//查询单个素材
export function getMaterialDetail(values) {
  return request('/material/queryOne', {
    method: 'POST',
    data: values,
  });
}
//新增素材
export function addMaterial(values) {
  return request('/material/add', {
    method: 'POST',
    data: values,
  });
}
//编辑素材
export function updateMaterial(values) {
  return request('/material/update', {
    method: 'POST',
    data: values,
  });
}

//删除单个素材
export function deleteMaterial(values) {
  return request('/material/delete', {
    method: 'POST',
    data: values,
  });
}
